import React from 'react'
import Body from './Body'

const Meals = () => {
    const _this = {}
    return (
        <Body {..._this} />
    )
}

export default Meals